export default "__VITE_ASSET__9d122174__"